import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { ModelLayout } from "../Layout";
import { FilePreviewProvider } from "@/contexts/FilePreviewProvider";
import { AnimatePresence } from "framer-motion";

export function ModelEmptyState() {
    const Sidebar = (
        <SidebarHeader
            title="Model Not Ready"
            description="Your model is still training or hasn't been created yet. Check back once your model has finished training."
        />
    );

    const VisualArea = (
        <FilePreviewProvider>
            <AnimatePresence mode="wait">
                <div className="visualArea">
                    <div className="flex h-full w-full flex-col items-center justify-center gap-3 rounded-lg border border-gray-100 bg-gray-50 text-tertiary">
                        <i className="fas fa-image text-5xl" />
                        <p className="text-sm">Model preview will appear here</p>
                    </div>
                </div>
            </AnimatePresence>
        </FilePreviewProvider>
    );

    return <ModelLayout Sidebar={Sidebar} VisualArea={VisualArea} />;
}

export function ModelErrorState() {
    const Sidebar = (
        <SidebarHeader
            title="Error Loading Model"
            description="An error occurred while loading model data. Please try again later."
        />
    );

    const VisualArea = (
        <FilePreviewProvider>
            <AnimatePresence mode="wait">
                <div className="visualArea">
                    <div className="flex h-full w-full flex-col items-center justify-center gap-3 rounded-lg border border-red-100 bg-red-50 text-red-600">
                        <i className="fas fa-triangle-exclamation text-5xl" />
                        <p className="text-sm">Model Error</p>
                    </div>
                </div>
            </AnimatePresence>
        </FilePreviewProvider>
    );

    return <ModelLayout Sidebar={Sidebar} VisualArea={VisualArea} />;
}
